import { type CompanySetupInput, type CompanySetupSuccess, toResponseError } from '@terros/common'
import { useTantalimMutation } from '../mutation'
import { type AddHookResponse, mutationAdd } from '../hooks'
import { useCompanyCache } from './cache'

export const useSetupCompany = (): AddHookResponse<CompanySetupInput, CompanySetupSuccess> => {
  const cache = useCompanyCache()
  const mutation = useTantalimMutation<CompanySetupInput, CompanySetupSuccess>({ url: '/company/setup' })

  async function add(input: CompanySetupInput): Promise<CompanySetupSuccess> {
    try {
      const output = await mutation.mutateAsync(input)
      cache.clearList()
      return output
    } catch (error) {
      throw toResponseError(error)
    }
  }

  return mutationAdd(mutation, add)
}
